import { MAX_AGGREGATE_COUNT } from '~/utils/constants/search'

export const state = () => ({
  consignees: [],
  totalConsignees: 0,
  sortField: 'CalculatedTEU',
  sortOrder: 'desc',
  currentPage: 1,
  pageLimit: 20,
  aggregateLimit: MAX_AGGREGATE_COUNT
})

export const getters = {
  aggregatedConsignees(state) {
    const start = (state.currentPage - 1) * state.pageLimit
    const end = state.currentPage * state.pageLimit

    return state.consignees.slice(start, end)
  }
}

export const mutations = {
  setConsignees(state, consignees) {
    state.consignees = consignees
  },
  setTotalConsignees(state, totalConsignees) {
    state.totalConsignees = totalConsignees
  },
  setSorting(state, { sortField, sortOrder }) {
    state.sortField = sortField
    state.sortOrder = sortOrder
  },
  setPageLimit(state, pageLimit) {
    state.pageLimit = +pageLimit
  },
  setCurrentPage(state, page) {
    state.currentPage = +page
  }
}

export const actions = {
  async fetchAggregatedConsignees({ state, commit, rootState, rootGetters }) {
    const requestId = 'fetchAggregatedConsignees'
    this.$axios.cancel(requestId)
    try {
      const { params } = rootGetters['search/searchQueryParam']()
      const sort = state.sortOrder === 'desc' ? '-' : ''

      params.set('sortBy', `${sort}${state.sortField}`)
      params.set('size', state.aggregateLimit)
      params.delete('limit')
      params.delete('page')

      const response = await this.$axios.$get(
        `${SHIPMENTS_API_URL}/v1/${rootState.country}/${
          rootState.tradeType
        }/shipments/aggregations/consignees`,
        {
          params,
          requestId,
          progress: false,
          headers: {
            ...(rootState.search.searchToken
              ? { 'x-search-token': rootState.search.searchToken }
              : {})
          }
        }
      )

      commit('setConsignees', response.data.items)
      commit('setTotalConsignees', response.data.total)
    } catch (error) {
      const response = error.response ? error.response.data : ''

      if (response.reason === 'Daily search limit exceeded') {
        return
      }
      if (this.$axios.isCancel(error)) {
        return // request has been canceled
      }
      throw error
    }
  },
  async setSorting({ commit, dispatch }, payload) {
    commit('setSorting', payload)
    commit('setCurrentPage', 1)
    dispatch('fetchAggregatedConsignees')
  },
  setPageLimit({ commit }, pageLimit) {
    commit('setPageLimit', pageLimit)
    commit('setCurrentPage', 1)
  },
  setCurrentPage({ state, commit }, page) {
    const { totalConsignees: total, pageLimit } = state
    const aggregateRowNumber = state.pageLimit * page

    // Calculate last page based on actual total from API
    if (aggregateRowNumber > total) {
      const lastPage = Math.ceil(total / pageLimit)
      return commit('setCurrentPage', lastPage)
    }

    commit('setCurrentPage', page)
  },
  resetConsigneesData({ commit }) {
    commit('setConsignees', [])
    commit('setTotalConsignees', 0)
    commit('setCurrentPage', 1)
  }
}
